import { useState, useEffect } from 'react';
import { getCurrentUser, fetchAuthSession } from 'aws-amplify/auth';
import { Hub } from 'aws-amplify/utils';
import { useNavigate } from 'react-router-dom';
import { CookiesProvider, useCookies } from 'react-cookie'

export default function useAuth() {
  const [isAuth, setIsAuth] = useState(null);
  const navigate = useNavigate();
  // const [cookies, setCookie] = useCookies(['CognitoIdentityServiceProvider.us-east-1_vXh8uo1UN'])

  useEffect(() => {
    // Check for authenticated user on mount (handles OAuth redirect)
    const checkCurrentUser = async () => {
      try {
        const currentUser = await getCurrentUser();
        if (currentUser && !isAuth) {
          console.log("Found authenticated user on mount");
          currentUser.expiryTTL = new Date().getTime() + (86400*1000);
          
          // Fetch and store the access token
          try {
            const session = await fetchAuthSession();
            const accessToken = session.tokens?.accessToken?.toString();
            if (accessToken) {
              // Store token in a format compatible with existing components
              // Preserve existing storage if it exists (for OAuth users)
              if (!currentUser.storage) {
                currentUser.storage = {};
              }
              const tokenKey = `CognitoIdentityServiceProvider.${currentUser.username}.accessToken`;
              currentUser.storage[tokenKey] = accessToken;
              
              // Only set keyPrefix if not already set (preserve OAuth structure)
              if (!currentUser.keyPrefix) {
                currentUser.keyPrefix = 'CognitoIdentityServiceProvider';
              }
              console.log("Access token stored for user");
            }
          } catch (tokenError) {
            console.log("Could not fetch access token:", tokenError);
          }
          
          setIsAuth(currentUser);
          localStorage.setItem("user", JSON.stringify(currentUser));
        }
      } catch (e) {
        console.log("No authenticated user on mount");
      }
    };
    
    checkCurrentUser();

    Hub.listen("auth", ({ payload: { event, data } }) => {
      // console.log("in hook useEffect");
      // console.log(event);
      // console.log(data)
      switch (event) {
        case "customOAuthState":
          // Cognito round-trips the `state` we passed in signInWithRedirect({ customState }).
          // Don't navigate here — Amplify strips the `?code=...&state=...` query by replacing
          // the URL with the configured redirectSignIn (`/`) shortly after this event fires,
          // which would clobber any navigate() we do. Instead, persist the target and let
          // App.jsx perform the redirect once the user is authenticated.
          try {
            if (typeof data === 'string' && data.startsWith('/')) {
              console.log("customOAuthState received, target:", data);
              localStorage.setItem("lastUrl", data);
            }
          } catch (e) {
            console.log("Error handling customOAuthState:", e);
          }
          break;
        case "signIn":
        case "signInWithRedirect":
          //console.log(getCurrentUser)
          getCurrentUser().then(async (currentUser) => {
            // console.log("in signin promise ");
            // console.log(JSON.stringify(currentUser));
            currentUser.expiryTTL = new Date().getTime() + (86400*1000);
            
            // Fetch and store the access token
            try {
              const session = await fetchAuthSession();
              const accessToken = session.tokens?.accessToken?.toString();
              if (accessToken) {
                // Store token in a format compatible with existing components
                if (!currentUser.storage) {
                  currentUser.storage = {};
                }
                const tokenKey = `CognitoIdentityServiceProvider.${currentUser.username}.accessToken`;
                currentUser.storage[tokenKey] = accessToken;
                currentUser.keyPrefix = 'CognitoIdentityServiceProvider';
                console.log("Access token stored for user on signIn");
              }
            } catch (tokenError) {
              console.log("Could not fetch access token:", tokenError);
            }
            
            setIsAuth(currentUser);
            localStorage.setItem("user", JSON.stringify(currentUser));
            // setCookie('CognitoIdentityServiceProvider.us-east-1_vXh8uo1UN', currentUser, { path: '/' ,secure})
          })
          break;
        case "oAuthSignOut":
        case "signOut":
          console.log("signing out");
          // Clear all user-related data from localStorage
          localStorage.removeItem("user");
          localStorage.removeItem("userId");
          localStorage.removeItem("userProfile");
          localStorage.removeItem("lastUrl");
          setIsAuth(null);
          // Navigate to login page
          navigate("/login");
          break;
        case "cognitoHostedUI":
          console.log("cognitoHostedUI event");
          checkCurrentUser();
          break;
      }
    });
  }, []);

  // console.log("isauth invoked and returned");
  // console.log(localStorage.getItem("user"))
  let userStorage = null;
  if(localStorage.getItem("user")){
    try{
     userStorage = JSON.parse(localStorage.getItem("user"));
    }catch(e){
      console.log("No user",e);
      userStorage = null;
    }
  }
  if(isAuth || userStorage){
    const currentTime = new Date().getTime();
    // console.log("Current time :",currentTime);
    if((isAuth && currentTime>isAuth.expiryTTL) || (userStorage && currentTime>userStorage.expiryTTL)){
      localStorage.removeItem("user");
      // console.log("user TTL has passed");
      userStorage = false;
      setIsAuth(null);
    }
  }
  return isAuth ? isAuth : userStorage;
  // return isAuth ? isAuth : false;
}